import { catalogTypeToSuitableClientType, clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import { ClientSelection } from './clientSelection.interface';

export const withMappedSelection = (selection: ClientSelection): ClientSelection => {
  const mappedValues: ClientSelection = {};
  if (selection.clientType) {
    mappedValues.catalogType = clientTypeToSuitableCatalogItemType(selection.clientType);
  } else if (selection.catalogType) {
    mappedValues.clientType = catalogTypeToSuitableClientType(selection.catalogType);
  }
  return Object.assign(mappedValues, selection);
};
